/* global Messenger */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS } from '../queryClient';
import { getQueryKey as getQueryKeyCriterias } from './useCriterias';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';

// Config
import { crudConfig } from '../../../conf/criteria';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.CRITERIA_DUPLICATE);

export const useDuplicateCriteria = ({ sessionToken, onSuccessCb, onErrorCb }) => {
    const Client = apiClient(crudConfig);

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: (copyingDTO) => Client.duplicateCriteria(sessionToken, copyingDTO.criteriaId, copyingDTO),
        onSuccess: (data) => {
            Messenger.showMessage({
                type: `success`,
                title: 'Criteria duplicated successfully.'
            });
            updateCacheArray({
                queryKey: getQueryKeyCriterias(),
                action: CACHE_ACTIONS.INSERT,
                primaryKey: crudConfig.primaryKey,
                data
            });
            onSuccessCb?.();
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        refetchOnWindowFocus: false
    });
};
